

export const headerData = {
    name: 'Ramki Marichamy',
    title: "MERN STACK Developer",
    desciption:"Looking forward to product based as well as startup's where i will develope myself and have a self growth in IT sector. I am very keen to work for the IT industry. ",
    image: 'https://raw.githubusercontent.com/ramki45/ramkiportfolio/main/src/assets/1663247944930.jpeg',
    resumePdf: "https://drive.google.com/file/d/1OQOnBT3S2Q02d1V84WHOOjr0dQcF4K3d/view?usp=sharing"
}
